import * as PIXI from 'pixi.js';
import { state } from '__common/store';
import { setupRendererLite } from './rendererLite';

let renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer;

export function setupRenderer(width: number, height: number) {
  if (state().app && state().app.isUbuilderLite) {
    renderer = setupRendererLite(width, height);
    return renderer;
  }
  renderer = PIXI.autoDetectRenderer(
    width,
    height,
    { antialias: true },
);

  return renderer;
}

export function getRenderer() {
  return renderer;
}

export function destroyRenderer() {
  if (renderer) {
    try {
      renderer.destroy();
    } catch (_) { /* already destroyed (e.g., HMR replayed unmount) */ }
    renderer = null;
  }
}
